const STORAGE_KEY = "locreach.activeWorkspaceId";
const CHANGE_EVENT = "locreach:workspace-changed";

let activeWorkspaceId = null;
let generation = 0;
const inFlightControllers = new Set();

function readStoredWorkspaceId() {
  if (typeof window === "undefined") return null;
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return value ? String(value).trim() || null : null;
  } catch {
    return null;
  }
}

function writeStoredWorkspaceId(value) {
  if (typeof window === "undefined") return;
  try {
    if (value) window.localStorage.setItem(STORAGE_KEY, value);
    else window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage is an optimization only.
  }
}

export function getActiveWorkspaceId() {
  if (activeWorkspaceId) return activeWorkspaceId;
  activeWorkspaceId = readStoredWorkspaceId();
  return activeWorkspaceId;
}

export function getWorkspaceGeneration() {
  return generation;
}

export function setActiveWorkspaceId(workspaceId) {
  const next = String(workspaceId || "").trim() || null;
  const previous = getActiveWorkspaceId();
  if (previous === next) return false;

  activeWorkspaceId = next;
  generation += 1;
  writeStoredWorkspaceId(next);

  inFlightControllers.forEach((controller) => {
    try {
      controller.abort();
    } catch {
      // Ignore already-completed requests.
    }
  });
  inFlightControllers.clear();

  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent(CHANGE_EVENT, {
        detail: { workspaceId: next, previousWorkspaceId: previous, generation },
      })
    );
  }
  return true;
}

export function clearActiveWorkspaceId() {
  return setActiveWorkspaceId(null);
}

export function registerWorkspaceRequest(controller) {
  if (!controller || typeof controller.abort !== "function") return () => {};
  inFlightControllers.add(controller);
  return () => inFlightControllers.delete(controller);
}

export function isWorkspaceRequestCurrent(workspaceId, requestGeneration) {
  return (
    String(workspaceId || "") === String(getActiveWorkspaceId() || "") &&
    Number(requestGeneration) === Number(generation)
  );
}

export function subscribeWorkspaceChange(listener) {
  if (typeof window === "undefined" || typeof listener !== "function") {
    return () => {};
  }
  const handler = (event) => listener(event?.detail || {});
  window.addEventListener(CHANGE_EVENT, handler);
  return () => window.removeEventListener(CHANGE_EVENT, handler);
}
